import React from 'react';

import AddFilesToCollection from 'features/media/AddFilesToCollection/AddFilesToCollection';
import FileSelectAllButton from 'features/media/components/molecules/FileSelectAllButton';
import VideoCompositionButton from 'features/media/components/molecules/VideoCompositionButton';
import { Flex } from 'shared/components/display';

import { COLLECTION_COPY } from 'shared/config/copy';
import { useCurrentUser } from 'shared/hooks/useCurrentUser';
import { BrkfstFile } from 'shared/typings/file';

import DownloadFilesButton from '../DownloadFilesButton';

import styles from './styles';

export interface SelectedFileActionsProps {
  selectedFiles: BrkfstFile[];
  collectionId: number;
  isMarketerCollection?: boolean;
  downloadInfo?: {
    brandName: string;
    orgName: string;
    briefName?: string;
    collectionName: string;
  };
  onSelectAllFilesClick: () => void;
  totalFiles: number;
}
const SelectedFileActions: React.FC<SelectedFileActionsProps> = ({
  collectionId,
  isMarketerCollection = false,
  downloadInfo,
  selectedFiles,
  onSelectAllFilesClick,
  totalFiles,
}) => {
  const { isSuperadmin } = useCurrentUser();
  const hasFilesSelected = selectedFiles.length > 0;
  return (
    <Flex css={styles} className="selected-file-actions">
      <FileSelectAllButton
        onSelectAllFilesClick={onSelectAllFilesClick}
        selectedFiles={selectedFiles}
        totalFiles={totalFiles}
      />
      {hasFilesSelected && (
        <>
          {isMarketerCollection && downloadInfo && (
            <>
              <DownloadFilesButton
                splitButtonVariant="secondary"
                selectedFiles={selectedFiles}
                downloadInfo={downloadInfo}
                tooltip={
                  isSuperadmin
                    ? COLLECTION_COPY.TOOLTIP_DOWNLOAD_SELECTED_FILES
                    : COLLECTION_COPY.TOOLTIP_DOWNLOAD_FILES
                }
              />
              <VideoCompositionButton selectedFiles={selectedFiles} />
            </>
          )}
          <AddFilesToCollection selectedFiles={selectedFiles} collectionId={collectionId} />
        </>
      )}
    </Flex>
  );
};

export default SelectedFileActions;
